import { render, staticRenderFns } from "./Secure.vue?vue&type=template&id=669b353c&scoped=true"
import script from "./Secure.vue?vue&type=script&lang=js"
export * from "./Secure.vue?vue&type=script&lang=js"
import style0 from "./Secure.vue?vue&type=style&index=0&id=669b353c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "669b353c",
  null
  
)

export default component.exports